import { render, staticRenderFns } from "./UserRoleRouteGuard.vue?vue&type=template&id=2c6bdb91"
import script from "./UserRoleRouteGuard.vue?vue&type=script&lang=ts"
export * from "./UserRoleRouteGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6bdb91')) {
      api.createRecord('2c6bdb91', component.options)
    } else {
      api.reload('2c6bdb91', component.options)
    }
    module.hot.accept("./UserRoleRouteGuard.vue?vue&type=template&id=2c6bdb91", function () {
      api.rerender('2c6bdb91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/guards/UserRoleRouteGuard.vue"
export default component.exports